module.exports = __webpack_public_path__ + "media/customizations/beaumont/logo-new-91e3d4012b81d399eb77276b3474017e.png";